import { useCallback, useEffect, useRef } from 'react'
import { gridFilteredSortedRowIdsSelector } from '@mui/x-data-grid'
import { scrollToSelectedRowInDataGrid } from 'utils/datagrid'
import { ROW_HEIGHT } from '../settings'

export const useDataGridInteractions = ({ selectedLocationId, onLocationChange, selectedTab, setExpandedRowIds, rows, apiRef }) => {
  const hasScrolledToSelectedLocation = useRef(false)
  const handleDetailPanelExpandedRowIdsChange = useCallback(
    newExpandedRowIds => {
      setExpandedRowIds(newExpandedRowIds)
    },
    [setExpandedRowIds]
  )

  const handleRowClick = useCallback(
    (params, event) => {
      if (
        event.target.closest('.MuiDataGrid-detailPanelToggleCell') ||
        event.target.closest('.MuiIconButton-root') ||
        event.target.closest('.MuiBadge-root') ||
        event.target.closest('svg')
      ) {
        return
      }

      if (params.row.locationId !== selectedLocationId) {
        onLocationChange(params.row.locationId)
      }
    },
    [selectedLocationId, onLocationChange, selectedTab]
  )

  const getRowClassName = useCallback(
    params => {
      return params.row.locationId === selectedLocationId ? 'location-row-selected' : ''
    },
    [selectedLocationId]
  )

  useEffect(() => {
    if (selectedLocationId && rows && rows.length > 0 && apiRef?.current && !hasScrolledToSelectedLocation.current) {
      const sortedIds = gridFilteredSortedRowIdsSelector(apiRef)
      const selectedRowIndex = sortedIds.findIndex(id => id === selectedLocationId)
      if (selectedRowIndex !== -1) {
        const rowHeight = ROW_HEIGHT
        setTimeout(() => {
          scrollToSelectedRowInDataGrid(apiRef, selectedRowIndex, rowHeight)
        }, 500)
        hasScrolledToSelectedLocation.current = true
      }
    }
  }, [selectedLocationId, rows, apiRef])

  return {
    handleDetailPanelExpandedRowIdsChange,
    handleRowClick,
    getRowClassName,
  }
}
